/** Canonical analytics event names (must stay aligned with fansfirst2/analytics/events.py). */

export const SCHEMA_VERSION = 1;

export const CANONICAL_EVENTS = [
  "league_selected",
  "team_selected",
  "game_selected",
  "team_search_selected",
  "team_search_unmatched",
  "games_list_opened",
  "games_page_loaded",
  "language_selected",
  "sell_clicked",
  "signup_clicked",
  "login_opened",
  "filter_applied",
  "filter_cleared",
  "filter_results_updated",
  "section_selected",
  "listing_selected",
  "listings_viewed",
  "checkout_started",
  "quantity_changed",
  "payment_method_selected",
  "coupon_applied",
  "coupon_rejected",
  "payment_submitted",
  "form_invalid",
  "payment_failed",
  "account_created",
  "login_completed",
  "logout_completed",
  "seller_listing_created",
  "purchase_completed",
  "refund_completed",
  "order_cancelled",
  "support_link_clicked",
  "social_link_clicked",
];

export const BROWSER_GTAG_BLOCKED = [
  "purchase_completed",
  "refund_completed",
  "order_cancelled",
];

const REQUIRED_KEYS = {
  league_selected: ["league"],
  team_selected: ["team"],
  game_selected: ["team", "game_id", "target"],
  team_search_selected: ["team", "page", "input"],
  team_search_unmatched: ["search_term", "page"],
  games_list_opened: ["team"],
  games_page_loaded: ["team", "mode"],
  language_selected: ["language"],
  sell_clicked: [],
  signup_clicked: [],
  login_opened: [],
  filter_applied: ["game_id", "filter", "value", "surface", "device_type"],
  filter_cleared: ["game_id", "filter"],
  filter_results_updated: [
    "game_id",
    "filter",
    "value",
    "surface",
    "device_type",
    "result_count",
    "active_filters",
    "zero_results",
  ],
  section_selected: ["game_id", "section_count"],
  listing_selected: [
    "game_id",
    "listing_id",
    "provider",
    "section",
    "price_band",
    "quantity",
    "surface",
  ],
  listings_viewed: ["team", "game_id", "listing_count"],
  checkout_started: [
    "checkout_attempt_id",
    "team",
    "game_id",
    "listing_id",
    "provider",
    "value",
    "quantity",
    "currency",
  ],
  quantity_changed: ["checkout_attempt_id", "game_id", "listing_id", "quantity"],
  payment_method_selected: ["checkout_attempt_id", "method"],
  coupon_applied: ["checkout_attempt_id"],
  coupon_rejected: ["checkout_attempt_id"],
  payment_submitted: ["checkout_attempt_id", "method"],
  form_invalid: ["checkout_attempt_id", "field"],
  payment_failed: ["checkout_attempt_id", "code", "step", "provider", "quantity"],
  account_created: [],
  login_completed: [],
  logout_completed: [],
  seller_listing_created: ["team", "quantity"],
  support_link_clicked: ["channel", "surface", "device_type"],
  social_link_clicked: ["network", "surface"],
  purchase_completed: ["order_id", "value", "currency"],
  refund_completed: ["order_id", "value", "currency"],
  order_cancelled: ["order_id", "reason_code"],
};

export function isCanonicalEvent(name) {
  return CANONICAL_EVENTS.includes(name);
}

export function validateEventProperties(eventName, properties) {
  if (!isCanonicalEvent(eventName)) {
    return false;
  }
  const required = REQUIRED_KEYS[eventName];
  if (!required) {
    return false;
  }
  const props = properties || {};
  return required.every((key) => props[key] !== undefined && props[key] !== null && props[key] !== "");
}
